import { useEffect, useState } from 'react';
import { EVENTO_PREFERENCIAS, leerDispositivoForzado } from './preferencias';

/**
 * Selección de variante de pantalla (ADR-0006).
 *
 * No es «responsive»: las pantallas que no se pueden adaptar razonablemente
 * tienen dos implementaciones distintas, con navegación distinta, y sólo se
 * descarga la que se va a usar. Esta función decide cuál.
 *
 * Se combina ancho con tipo de puntero porque ninguno de los dos basta: una
 * tableta de 1280 px con dedos necesita objetivos táctiles y barra inferior,
 * mientras que un portátil de 1024 px con ratón necesita la densidad del
 * escritorio.
 */
export type Device = 'movil' | 'escritorio';

export const ESCRITORIO_MIN_PX = 1024;

const CONSULTA = `(min-width: ${ESCRITORIO_MIN_PX}px) and (pointer: fine)`;

export function detectDevice(): Device {
  const forzado = leerDispositivoForzado();
  if (forzado) return forzado;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    // Sin `window` (pruebas, prerenderizado) se asume móvil: es la variante que
    // funciona en ambos sitios, sólo con menos densidad.
    return 'movil';
  }
  return window.matchMedia(CONSULTA).matches ? 'escritorio' : 'movil';
}

export function useDevice(): Device {
  const [device, setDevice] = useState<Device>(detectDevice);

  useEffect(() => {
    const consulta = window.matchMedia(CONSULTA);
    const alCambiar = (): void => setDevice(detectDevice());
    consulta.addEventListener('change', alCambiar);
    window.addEventListener(EVENTO_PREFERENCIAS, alCambiar);
    return () => {
      consulta.removeEventListener('change', alCambiar);
      window.removeEventListener(EVENTO_PREFERENCIAS, alCambiar);
    };
  }, []);

  return device;
}
